/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  toggleFavorite(conversationID) {
    return axios.post(`${this.url}/${conversationID}/favorite`);
  }

  removeFavorite(conversationID) {
    return axios.delete(`${this.url}/${conversationID}/favorite`);
  }
}

export default new ConversationApi();
